import { render, staticRenderFns } from "./wrapperTable.vue?vue&type=template&id=e6688b2c&scoped=true"
import script from "./wrapperTable.vue?vue&type=script&lang=js"
export * from "./wrapperTable.vue?vue&type=script&lang=js"
import style0 from "./wrapperTable.vue?vue&type=style&index=0&id=e6688b2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6688b2c",
  null
  
)

export default component.exports